import { useState } from "react";

import styles from "./cell-json.module.css";

export function CellJSON(props: {
  value: Record<string, unknown> | null | undefined;
}) {
  const [expanded, setExpanded] = useState(false);

  // Handle null/undefined values
  if (props.value == null) {
    return <div className={styles.root} />;
  }

  return (
    <div className={styles.root}>
      {!expanded && (
        <>
          <div className={styles.plainJson}>{JSON.stringify(props.value)}</div>

          <div className="grow" />
        </>
      )}

      {expanded && (
        <table className={styles.table}>
          <tbody>
            {Object.entries(props.value).map(([key, value]) => (
              <tr key={key}>
                <td>{prettyKey(key)}</td>
                <td>
                  {typeof value === "string" ? value : JSON.stringify(value)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <button
        type="button"
        onClick={() => {
          setExpanded(!expanded);
        }}
        className={styles.button}
      >
        {expanded ? "\u25B2" : "\u25BC"}
      </button>
    </div>
  );
}

function prettyKey(key: string) {
  const pretty = key.replace(/_/g, " ");
  return pretty.charAt(0).toUpperCase() + pretty.slice(1);
}
